import { AppRoutes } from "../constants";
import { IProject } from "../pages/AddEditNGOPage/const";

export interface MongodbDocument {
    _id: string;
    createdAt: Date;
    updatedAt: Date;
    __v: number;
}

export interface FileType extends MongodbDocument {
    filename: string;
    originalname: string;
    mimetype: string;
    size: number;
    url: string;
}

export interface OrganizationType extends MongodbDocument {
    logo?: FileType;
    name: string;
    title: string;
    description: string;
    isVoting: boolean;
    votingLimit: number;
    email: string;
    isEmployerMatching: boolean;
    role: UserRole | undefined;
    fundraisingDate: Date | null;
    isActive: boolean;
    contact_person_name: string;
    contact_person_email: string;
    contact_person_mobile: string;
}

export interface ExtOrganizationType extends OrganizationType {
    totalNGOs: number;
    totalCities: number;
}

export interface IOrganizationCities extends MongodbDocument {
    city: ICity;
    isActive: boolean;
    organization: string;
}

interface NGOCity extends MongodbDocument {
    cityId: string;
    cityOrgId: string;
    cityName: string;
    isActive: boolean;
    organization: string;
}

export interface ICategory {
    name: string;

}

export interface CategoryType extends MongodbDocument {
    name: string;
}

export interface IFile {
    _id: string;
    url: string;
    name: string;
    mimeType: string;
    size: string;
    createdBy: string;
    createdAt: string;
    updatedAt: string;
}

export interface INGO_V2 extends MongodbDocument {
    name: string;
    tagline: string;
    summary: string;
    about: string;
    email?: string;
    websiteUrl?: string;
    category: ICategory;
    cities: string[];
    darpanId: string;
    logo?: IFile;
    eightyGCertificate?: IFile;
    trustDeedCertificate?: IFile;
    projects: IProject[];
    goal?: number;
    achievedAmount?: number;
}

export interface INGO extends MongodbDocument {
    image: string;
    title: string;
    name: string;
    description?: string;
    about?: string;
    type: CategoryType;
    organization: string;
    cities: NGOCity[];
    totalVotes: number;
    totalDonations: number;
    totalGoal: number;
    isDonationEnabled: boolean;
}

export interface SelectOption {
    label: string;
    value: string
}

export interface ICity extends MongodbDocument {
    city: string;
    state: string;
    country: string;
    isOwned?: boolean;
    createdBy?: string;
    updatedBy?: string;
}

export interface BasePayload {
    page?: number;
    limit?: number;
    search?: string;
}

export enum UserRole {
    SUPER_ADMIN = "SUPER_ADMIN",
    ORGANIZATION_MEMBER = "ORGANIZATION_MEMBER",
    NGO_MEMBER = "NGO_MEMBER",
    DONOR = "DONOR"
}

export const ROLE_REDIRECT_MAP: Record<UserRole, string> = {
    [UserRole.SUPER_ADMIN]: AppRoutes.ADMIN.HOME,
    [UserRole.ORGANIZATION_MEMBER]: AppRoutes.ORGANIZATION.HOME,
    [UserRole.NGO_MEMBER]: AppRoutes.ORGANIZATION.HOME,
    [UserRole.DONOR]: AppRoutes.ORGANIZATION.HOME,
};

export enum RsvpStatus {
    YES = 'yes',
    NO = "no",
    MAYBE = "maybe"
}